(function () {
  function trackGa4(eventName, params) {
    if (typeof window.gtag !== 'function') return
    if (params && Object.keys(params).length > 0) {
      window.gtag('event', eventName, params)
    } else {
      window.gtag('event', eventName)
    }
  }

  function bindLeadForms() {
    document.querySelectorAll('.vera-signup-form').forEach(function (form) {
      if (form.dataset.veraGaLeadBound === '1') return
      form.dataset.veraGaLeadBound = '1'
      form.addEventListener('submit', function () {
        trackGa4('generate_lead', { lead_source: 'cta' })
      })
    })
  }

  if (window.__veraAnalyticsContact) {
    trackGa4('contact')
    window.__veraAnalyticsContact = false
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLeadForms)
  } else {
    bindLeadForms()
  }
})()
